import { render, staticRenderFns } from "./DataViewContacts.vue?vue&type=template&id=78ae7328&"
import script from "./DataViewContacts.vue?vue&type=script&lang=js&"
export * from "./DataViewContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports